(function($){
    jQuery(document).ready(function(){
        $("h1, h2, h3, h4, h5, h6").addClass("header-font");
    })}
)(jQuery);

jQuery(window).scroll(function() {    
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 2) {
        jQuery('header.header').addClass('scrolled');
    } else {
        jQuery('header.header').removeClass('scrolled');
    }
});